var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNextArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 15,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1804_820",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 7,
    width: 24,
    height: 24
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 7,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1804_820)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.9125 28.1125C16.4223 28.6027 15.6277 28.6027 15.1375 28.1125C14.6473 27.6223 14.6473 26.8277 15.1375 26.3375L22.475 19L15.1375 11.6625C14.6473 11.1723 14.6473 10.3777 15.1375 9.8875C15.6277 9.39735 16.4223 9.39735 16.9125 9.8875L25.3179 18.2929C25.7084 18.6834 25.7084 19.3166 25.3179 19.7071L16.9125 28.1125Z",
    fill: "#5250ED"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextArrow);
export default __webpack_public_path__ + "static/media/nextArrow.1d351b740dfcfa137890b587bad4c69d.svg";
export { ForwardRef as ReactComponent };